import { computed, ref } from 'vue'
import { useUserStore } from '~/stores/user'
import { useAnonGateAnalyticsContext } from '~/composables/useAnonGateAnalyticsContext.js'

const modalVisible = ref(false)

export function useLoginToDownload() {
  const userStore = useUserStore()
  const route = useRoute()
  const { setAuthContext } = useAnonGateAnalyticsContext()
  const isLoggedIn = computed(() => Boolean(userStore.token))

  function openLoginToDownloadModal() {
    modalVisible.value = true
  }

  function closeLoginToDownloadModal() {
    modalVisible.value = false
  }

  /**
   * @param {{ source_module?: string, file_type?: string, task_id?: string }} [meta]
   * @returns {boolean} true if download may proceed
   */
  function requireLoginToDownload(meta = {}) {
    if (isLoggedIn.value) return true
    try {
      const nuxtApp = useNuxtApp()
      const source_module = meta.source_module || 'history_card'
      const file_type = meta.file_type || 'video'
      const task_id = meta.task_id != null ? String(meta.task_id).trim() : ''
      void import('~/utils/lipsyncAnalytics.js').then(({ trackAnonymousDownloadClick }) => {
        trackAnonymousDownloadClick(
          nuxtApp.$sendLog,
          {
            source_module,
            file_type,
            ...(task_id ? { task_id } : {}),
          },
          { userStore, route },
        )
      })
    } catch {
      /* analytics must not block download gate */
    }
    openLoginToDownloadModal()
    return false
  }

  function continueToLoginFromDownload() {
    closeLoginToDownloadModal()
    setAuthContext({ from: 'download_click', triggerType: 'click' })
    userStore.setLoginModalShow(true)
  }

  return {
    modalVisible,
    isLoggedIn,
    openLoginToDownloadModal,
    closeLoginToDownloadModal,
    requireLoginToDownload,
    continueToLoginFromDownload,
  }
}
